import React from "react";

class NotFound extends React.Component {
  render() {
    return (
      <div data-testid="not-found">We're sorry! This page doesn't exist.</div>
    );
  }
}

export default NotFound;
